module.exports = __webpack_public_path__ + "static/business-bee6760a880a8035cefcf277bb3140be.svg";